import { useEffect, useState } from "react";

const useDebounce = <T>(value: T, delay: number = 300): T | null => {
  const [debouncedValue, setDebouncedValue] = useState<T | null>(value || null);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (value === "") {
        setDebouncedValue(null);
      } else {
        setDebouncedValue(value);
      }
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export default useDebounce;
